export const StarMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path
      d="M32 6 L37.88 23.91 L56.7 23.97 L41.51 35.09 L47.28 53.03 L32 42 L16.72 53.03 L22.49 35.09 L7.3 23.97 L26.12 23.91 Z"
      fill="none"
      stroke="url(#starGold)"
      strokeWidth="2.6"
      strokeLinejoin="round"
    />
    <path
      d="M32 6 L37.88 23.91 L56.7 23.97 L41.51 35.09 L47.28 53.03 L32 42 L16.72 53.03 L22.49 35.09 L7.3 23.97 L26.12 23.91 Z"
      fill="none"
      stroke="#F3E5AB"
      strokeWidth="1.4"
      strokeLinejoin="round"
      transform="translate(32 32) scale(0.62) translate(-32 -32)"
      opacity="0.85"
    />
    <defs>
      <linearGradient id="starGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F3E5AB" />
        <stop offset="1" stopColor="#D4AF37" />
      </linearGradient>
    </defs>
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <StarMark className="h-7 w-7 shrink-0" />
    <span className="leading-none">
      <span className="block font-display text-xl tracking-wide text-[#F9F8F6]">
        Salão <span className="italic text-gold-gradient">Estrela</span>
      </span>
      <span className="mt-1 block text-[9px] uppercase tracking-[0.35em] text-[#A1A09E]">
        Extensões &amp; Mega Hair
      </span>
    </span>
  </span>
);
